module.exports = __webpack_public_path__ + "img/ccf-2.9ab37166.webp";